var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"presentation-page"},[_c('div',{staticClass:"presentation-page__wrapper"},[_c('div',{staticClass:"presentation-page__content"},[_vm._t("default")],2),_c('PresentationPageFooter',{attrs:{"page-number":_vm.pageNumber,"page-count":_vm.pageCount}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }